import { BaseScopes } from "../models/scopes";
import { GSEndpoint } from "../models/endpoint";
import { User } from "../models/user";

export interface AnnouncementI {
    announcementId?: string;
    appName?: string;
    groupId?: string;
    title: string;
    message: string;
    creationDate?: string;
    startTime?: string;
    expirationTime?: string;
}

interface AnnouncementQueryParams {
    appName: string;
    groupId: string;
}

export class GetAllAnnouncements extends GSEndpoint<{}, AnnouncementI[], {}> {
    constructor() {
        super("announcements/all", "GET", [BaseScopes.ANNOUNCE, BaseScopes.MAINTAIN], {});
    }

    override async request(user: User): Promise<AnnouncementI[]> {
        return await super.makeRequest({}, user);
    }
}

export class GetAnnouncements extends GSEndpoint<{}, AnnouncementI[], AnnouncementQueryParams> {
    constructor(appName: string, groupId: string) {
        super("announcements", "GET", [BaseScopes.ANNOUNCE, BaseScopes.MAINTAIN], { appName, groupId });
    }

    override async request(user: User): Promise<AnnouncementI[]> {
        return await super.makeRequest({}, user);
    }
}

export class PostAnnouncement extends GSEndpoint<AnnouncementI, {}, AnnouncementQueryParams> {
    constructor(appName: string, groupId: string) {
        super("announcements", "POST", [BaseScopes.ANNOUNCE, BaseScopes.MAINTAIN], { appName, groupId });
    }

    override async request(req: AnnouncementI, user: User): Promise<{}> {
        return await super.makeRequest(req, user);
    }
}

export class DeleteAnnouncement extends GSEndpoint<{}, {}, AnnouncementQueryParams> {
    constructor(announcementId: string, appName: string, groupId: string) {
        super("announcements/{announcementId}", "DELETE", [BaseScopes.ANNOUNCE, BaseScopes.MAINTAIN], { appName, groupId }, [announcementId]);
    }

    override async request(user: User): Promise<{}> {
        return await super.makeRequest({}, user);
    }
}

